export const isCurrentLink = (hrefs: string | string[], pathname: string) => {
  if (Array.isArray(hrefs)) {
    return hrefs.some((href) => pathname.includes(href));
  }
  return pathname.includes(hrefs);
};
